export default "__VITE_ASSET__Blr185rJ__"